import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { usernameSelector, securityCodeSelector, isResetingSelector } from '../selectors/authSelectors';
import { deleteSecurityCode, resetPasswordRequest } from '../actions/authActions';
import ResetPasswordForm from '../components/ResetPasswordForm/ResetPasswordForm';

const mapStateToProps = createStructuredSelector({
    isReseting: isResetingSelector,
    securityCode: securityCodeSelector,
    username: usernameSelector
});

const mapDispatchToProps = {
    deleteSecurityCode,
    resetPasswordRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);
